// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__26r_C","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__24tzg"};